












import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Mutation } from 'vuex-class'
import UserImage from '@/components/UserImg'

@Component({
  components: {
    UserImage
  }
})
export default class PersonSelect extends Vue {
  @State('userImg') userImg !: number
  @Mutation('setUserImg') setUserImg!: (i: number) => void
  private isActive = false
  imgSelectToggle () {
    this.isActive = !this.isActive
  }
  imgOnClick (imgIndex: number) {
    console.log(imgIndex)
    this.setUserImg(imgIndex)
    this.isActive = false
  }
}
